import { createSlice } from "@reduxjs/toolkit";
import { PAGELENGTH } from "components/common/ListLayout";
import Api from "services/api";

export const initialState = {
  translations: [],
  error: null,
  loader: false,
  total: 0,
  is_more: false,
  current_page: 1,
  per_page: PAGELENGTH,
  last_page: 1,
};

export const translationSlice = createSlice({
  name: "translation",
  initialState: initialState,
  reducers: {
    setTranslations: (state, { payload }) => {
      state.translations = payload?.data ?? payload;
      console.log("payload", payload?.data);
      state.total = payload?.data?.total;
      state.is_more = payload?.data?.is_more;
      state.last_page = payload?.data?.last_page;
      state.current_page = payload?.data?.current_page;
      state.per_page = payload?.data?.per_page;
    },
    removeTranslationFromStore: (state, { payload }) => {
      const ids = Array.isArray(payload) ? payload : [payload];
      const idSet = new Set(ids.map((i) => String(i)));
      try {
        if (state.translations && Array.isArray(state.translations.data)) {
          const before = state.translations.data.length;
          state.translations.data = state.translations.data.filter(
            (t) => !idSet.has(String(t.id))
          );
          const after = state.translations.data.length;
          const removed = Math.max(0, before - after);
          state.total = Math.max(0, (state.total || 0) - removed);
        } else if (Array.isArray(state.translations)) {
          const before = state.translations.length;
          state.translations = state.translations.filter(
            (t) => !idSet.has(String(t.id))
          );
          const after = state.translations.length;
          const removed = Math.max(0, before - after);
          state.total = Math.max(0, (state.total || 0) - removed);
        }
      } catch (e) {
        console.error("removeTranslationFromStore error", e);
      }
    },
    setMoreTranslations: (state, { payload }) => {
      state.translations = state.translations.concat(payload.data);
      state.total = payload.total;
      state.is_more = payload.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.data?.current_page;
      state.per_page = payload?.per_page;
    },
    setError: (state, { payload }) => {
      state.error = payload;
    },
    setLoader: (state, { payload }) => {
      state.loader = payload;
    },
    clearAllTranslations: (state) => {
      state.translations = [];
      state.error = null;
      state.loader = false;
      state.total = 0;
      state.is_more = false;
      state.current_page = 1;
      state.per_page = PAGELENGTH;
      state.last_page = 1;
    },
  },
});

export const fetchTranslationsList =
  (page, params, status, disableLoader = false, asyncMode = false) =>
  async (dispatch) => {
    !disableLoader && dispatch(setLoader(true));
    try {
      const result = await Api.fetchTranslation(page, params, status);

      if (result.status >= 200 && result.status < 300) {
        const data = result?.data?.data;
        if (page > 1) {
          dispatch(setTranslations({ data }));
          if (!disableLoader) dispatch(setLoader(false));
        } else {
          dispatch(setTranslations({ data }));
          if (!disableLoader) dispatch(setLoader(false));
        }
      } else if (result?.status === 422) {
        if (asyncMode) return [];
        dispatch(setError(result.data));
        if (!disableLoader) dispatch(setLoader(false));
      }
    } catch (error) {
      console.log("error", error);
    }

    !disableLoader && dispatch(setLoader(false));
  };

// Fetch translation by ID
export const getTranslationById = (transId, callback) => async (dispatch) => {
  dispatch(setError(null));
  dispatch(setLoader(true));
  try {
    const json = await Api.fetchTranslationById(transId);
    if (json.status >= 200 && json.status < 300) {
      callback(true, json.data.data);
    } else if (json.status === 422) {
      dispatch(setError(json.data));
      callback(false, json.data.message);
    }
  } catch (error) {
    console.log(error);
  }
  dispatch(setLoader(false));
};
export const getQuoation = (id, callback) => async (dispatch) => {
  try {
    const json = await Api.fetchReviseQuote(id);
    if (json.status >= 200 && json.status < 300) {
      callback(true, json.data.data);
    } else if (json.status === 422) {
      dispatch(setError(json.data));
      callback(false, json.data.message);
    }
  } catch (error) {
    console.log(error);
  }
};

// Fetch translation logs by ID
export const getTransLogs = (transId, callback) => async (dispatch) => {
  dispatch(setError(null));
  dispatch(setLoader(true));
  try {
    const json = await Api.fetchTransLogs(transId);
    if (json.status >= 200 && json.status < 300) {
      callback(true, json.data?.message, json?.data?.data);
      console.log("json", json);
    } else if (json.status === 422) {
      dispatch(setError(json.data));
      callback(false, json.data.message);
    }
  } catch (error) {
    console.log(error);
  }
  dispatch(setLoader(false));
};

// Update translation
export const updateTranslation =
  (data, itemId, callback) => async (dispatch) => {
    dispatch(setError(null));
    dispatch(setLoader(true));
    try {
      const json = await Api.updateTranslation(data, itemId);
      if (json.status >= 200 && json.status < 300) {
        callback(true, json.data.message);
      } else if (json.status === 422) {
        dispatch(setError(json.data));
        callback(false, json.data.message);
      }
    } catch (error) {
      console.log(error);
    }
    dispatch(setLoader(false));
  };

// remove Translation
export const removeTranslation = (itemId, callback) => async (dispatch) => {
  dispatch(setError(null));
  dispatch(setLoader(true));
  try {
    const json = await Api.removeTranslation(itemId);
    if (json.status >= 200 && json.status < 300) {
      // Remove from redux store so UI updates immediately
      dispatch(removeTranslationFromStore(itemId));
      callback(true, json.data.message);
    } else if (json.status === 422) {
      dispatch(setError(json.data));
      callback(false, json.data.message);
    }
  } catch (error) {
    console.log(error);
  }
  dispatch(setLoader(false));
};

export const approveQuote = (itemId, callback) => async (dispatch) => {
  dispatch(setError(null));
  dispatch(setLoader(true));
  try {
    const json = await Api.approveQuote(itemId);
    if (json.status >= 200 && json.status < 300) {
      callback(true, json.data.message);
    } else if (json.status === 422) {
      dispatch(setError(json.data));
      callback(false, json.data.message);
    }
  } catch (error) {
    console.log(error);
  }
  dispatch(setLoader(false));
};
export const rejectQuote = (itemId, data, callback) => async (dispatch) => {
  dispatch(setError(null));
  dispatch(setLoader(true));
  try {
    const json = await Api.rejectQuote(itemId, data);
    if (json.status >= 200 && json.status < 300) {
      callback(true, json.data.message);
    } else if (json.status === 422) {
      dispatch(setError(json.data));
      callback(false, json.data.message);
    }
  } catch (error) {
    console.log(error);
  }
  dispatch(setLoader(false));
};

export const {
  setTranslations,
  setMoreTranslations,
  setError,
  setLoader,
  clearAllTranslations,
  removeTranslationFromStore,
} = translationSlice.actions;

export default translationSlice.reducer;
export const translationSelector = (state) => state.translation;
